import { render, staticRenderFns } from "./pageCategoryTree.vue?vue&type=template&id=71d7a6d6&scoped=true&"
import script from "./pageCategoryTree.vue?vue&type=script&lang=babel&"
export * from "./pageCategoryTree.vue?vue&type=script&lang=babel&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d7a6d6",
  null
  
)

export default component.exports